import { render, staticRenderFns } from "./SpotifyButton.vue?vue&type=template&id=88a7e63c&"
import script from "./SpotifyButton.vue?vue&type=script&lang=js&"
export * from "./SpotifyButton.vue?vue&type=script&lang=js&"
import style0 from "./SpotifyButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports